module.exports = __webpack_public_path__ + "static/media/publish-private.6e49a0a1.svg";